<script lang="ts">
  import { triggerOpportunityDataRefresh } from "../../lib/syncDashboardRefresh";
  import EngagementInvitationsTable from "./engagementInvitationsTable.svelte";

  const baseUrl = `${process.env.SVELTE_APP_REMOTE_URL}/api`;
  const aceBaseUrl = `${baseUrl}/aws-partner-central`;
  const rejectionReasons = [
    "Customer problem unclear",
    "Next steps unclear",
    "Unable to support",
    "Duplicate of partner referral",
    "Other",
  ];

  const refreshSyncViews = () => {
    triggerOpportunityDataRefresh();
  };

  const acceptInvitation = async (row: { id?: string }) => {
    if (!row?.id) {
      return { success: false, message: "Invitation identifier is missing." };
    }

    const res = await fetch(`${aceBaseUrl}/accept-engagement-invitation`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ identifier: row.id }),
    });

    return res.json();
  };

  const syncAcceptedOpportunity = async (opportunityId: string) => {
    const syncRes = await fetch(`${baseUrl}/sync/from-aws/${opportunityId}`, {
      method: "POST",
    });
    const syncResult = await syncRes.json();

    if (syncRes.ok && syncResult?.success) {
      refreshSyncViews();
      return syncResult;
    }

    return syncResult;
  };

  const rejectInvitation = async (row: {
    id?: string;
    rejectionReason?: string;
  }) => {
    if (!row?.id) {
      return { success: false, message: "Invitation identifier is missing." };
    }

    if (!row.rejectionReason) {
      return { success: false, message: "Rejection reason is required." };
    }

    const res = await fetch(`${aceBaseUrl}/reject-engagement-invitation`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        identifier: row.id,
        rejectionReason: row.rejectionReason,
      }),
    });

    return res.json();
  };
</script>

<div class="w-full">
  <EngagementInvitationsTable
    title="Pending Engagement Invitations"
    {rejectionReasons}
    onAccept={acceptInvitation}
    onSyncAcceptedOpportunity={syncAcceptedOpportunity}
    onReject={rejectInvitation}
  />
</div>
